import axios from 'axios'
import sysConfig from '@/../config/sysConfig'
import service from '@/../config/serviceList'
import http from './../../base/api/public'
import router, {resetRouter} from '@/base/router'

let Base64 = require('js-base64').Base64
import {getToken, setToken, deleteToken, getJWT, setJWT, deleteJWT,setRefreshToken,getRefreshToken,deleteRefreshToken} from '@/common/oauth'
import {setExpireIn} from "../../common/oauth";

require('es6-promise').polyfill()

// 定义用户状态数据，等后台功能完成以后再完善
const state = {
  token: getToken(), // 服务端返回的token
  nickname: '', // 登陆用户的昵称
  avatar: '', // 登陆用户的头像 ...
  realName: '',
  operatorIdList: [],
  operatorId: '',
  groupIdList: [],
  customerIdList: [],
  roleIdList: [],
  permissions: [],
  userType: '',
  platformName: '',
  homePage: '',
  // 完整的用户信息
  userDetail: {}
}

// 定义mutations 来更改状态
const mutations = {
  set_token(state, token) {
    state.token = token
  },
  set_nickname(state, nickname) {
    state.nickname = nickname
  },
  set_avatar(state, avatar) {
    state.avatar = avatar
  },
  set_realName(state, realName) {
    state.realName = realName
  },
  set_operatorIdList(state, operatorIdList) {
    state.operatorIdList = operatorIdList
  },
  set_operatorId(state, operatorId) {
    state.operatorId = operatorId
  },
  set_groupIdList(state, groupIdList) {
    state.groupIdList = groupIdList
  },
  set_customerIdList(state, customerIdList) {
    state.customerIdList = customerIdList
  },
  set_roleIdList(state, roleIdList) {
    state.roleIdList = roleIdList
  },
  set_permissions(state, permissions) {
    state.permissions = permissions
  },
  set_userType(state, userType) {
    state.userType = userType
  },
  set_platformName(state, platformName) {
    state.platformName = platformName
  },
  set_homePage(state, homePage) {
    state.homePage = homePage
  },
  set_userDetail(state, userDetail) {
    state.userDetail = userDetail
  }
}


// 自定义触发mutations里函数的方法
const actions = {

  // user login
  login({commit}, userInfo) {
    //console.log('进入vuex user的login方法，传递的参数是:' + JSON.stringify(userInfo))
    const {username, password} = userInfo
    // 登录参数
    const loginParam = {
      'username': username,
      'password': password,
      'clientId': sysConfig.clientId,
      'clientSecret': sysConfig.clientSecret,
      'clientType': 'pc'
    }
    // 请求地址
    const http = sysConfig.apiPre + service.oauth + '/user/login'
    console.log("请求地址:" + http)
    // 调用axios进行登陆
    return new Promise((resolve, reject) => {
      axios.post(http, loginParam, {
        // 配置
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        const {data} = response
        console.log('登录返回数据:' + JSON.stringify(data))
        const access_token = data.access_token
        const refresh_token = data.refresh_token
        const expireIn = data.expires_in
        commit('set_token', access_token)
        // 设置Cookie*/
        setToken(access_token)
        setRefreshToken(refresh_token)
        // 设置sessionStorage
        setJWT(data.jwt_token)
        setExpireIn(expireIn)

        resolve({isSuccess: true, data: data})
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 模拟用户的退出功能:
   * 用户退出时应该在后台时缓存的token失效，并且前端做的应该是:
   * 1.vuex中保存的token,nickname,avatar设为空值
   * 2.Cookie中保存的token置空
   * 3.重置路由到登陆页面
   */
  logout({commit}) {
    const logOutUrl = sysConfig.apiPre + service.oauth + '/user/logout/' + getToken();
    return new Promise((resolve, reject) => {
      axios.get(logOutUrl).then(res => {
        commit('set_token', '')
        // 清除缓存中的用户信息
        commit('set_nickname', '')
        commit('set_operatorIdList', [])
        commit('set_operatorId', '')
        commit('set_groupIdList', [])
        commit('set_customerIdList', [])
        commit('set_roleIdList', [])
        commit('set_permissions', [])
        commit('set_userType', '')
        commit('set_userDetail', {})
        deleteRefreshToken()
        deleteToken()
        // 清除session中的jwt令牌
        deleteJWT()
        // 重置路由
        resetRouter()

        resolve({isSuccess: true})
      }).catch(error => {
        reject(error)
      })
    })
  },
  refreshToken({commit}){
    const refreshTokenUrl = sysConfig.apiPre + service.oauth + '/user/refresh'
    // 登录参数
    const refreshParam = {
      'clientId': sysConfig.clientId,
      'clientSecret': sysConfig.clientSecret,
      'refreshToken': getRefreshToken(),
      'accessToken':getToken()
    }
     return new Promise((resolve,reject) => {
       axios.post(refreshTokenUrl,refreshParam,{
         // 配置
         headers: {
           'Content-Type': 'application/json'
         }
       }).then(response => {
         const {data} = response
         const access_token = data.access_token
         const refresh_token = data.refresh_token
         const expireIn = data.expires_in
         commit('set_token', access_token)
         // 设置Cookie*/
         setToken(access_token)
         setRefreshToken(refresh_token)
         // 设置sessionStorage
         setJWT(data.jwt_token)
         setExpireIn(expireIn)

         //否则失败
         resolve({isSuccess:true,data: data})
       }).catch(error => {
          reject(error)
       })
     })
  },
  // 重置token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('set_token', '')
      deleteToken()

      // 清除缓存中的用户信息
      commit('set_nickname', '')
      commit('set_operatorIdList', [])
      commit('set_operatorId', '')
      commit('set_groupIdList', [])
      commit('set_customerIdList', [])
      commit('set_roleIdList', [])
      commit('set_permissions', [])
      commit('set_userType', '')
      commit('set_userDetail', {})

      // 清除session中的jwt令牌
      deleteJWT()

      // 重置路由
      resetRouter()

      resolve({isSuccess: true})
    })
  },
  // 获取登录用户详细信息
  getUserInfo({commit}, username) {
    const url = sysConfig.apiPre + service.rbac + '/rbac/user/userInfoDetail?username=' + username
    return new Promise((resolve, reject) => {
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        const {username, realName, type, operatorIdList, operatorId, platformName, homePage, groupIdList, customerIdList, roleIdList, permissions} = res.data

        commit('set_nickname', username)
        commit('set_realName', realName)
        commit('set_operatorIdList', operatorIdList)
        commit('set_operatorId', operatorId)
        commit('set_groupIdList', groupIdList)
        commit('set_customerIdList', customerIdList)
        commit('set_roleIdList', roleIdList)
        commit('set_permissions', permissions)
        commit('set_userType', type)
        commit('set_platformName', platformName)
        commit('set_homePage', homePage)
        commit('set_userDetail', res.data)

        resolve({permissions: permissions, userType: type})

      }).catch(error => {
        console.log(error);
        reject(error)
      })
    })
  },
  // 清除redis中的用户信息
  deleteUserInfo({commit}, nickname) {
    const url = sysConfig.apiPre + service.rbac + '/rbac/user/logout/' + nickname
    return new Promise((resolve, reject) => {
      axios.post(url, {}, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log('清除redis中的用户信息成功')
        resolve({isSuccess:true})
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserJWT({commit}) {
    return new Promise((resolve, reject) => {
      http.requestQuickGet(sysConfig.apiPre + service.oauth + '/user/userJWT/' + getToken()).then((res) => {
        console.log('获取到的jwt为：' + JSON.stringify(res))
        const {data} = res
        // 设置sessionStorage
        setJWT(data.jwt_token)
        resolve({isSuccess: true, data: data})
      }).catch(error => {
        reject(error)
      })
    })
  }
}
// 导出状态
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js